(async () => {

  if (!customElements.get('product-recommendations')) {

    const { default: Swiper} = await import("swiper");
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-recommended-products]');

        this.swiperOptions = {
          loop: false,
          autoplay: false,
          direction: 'horizontal',
          spaceBetween: 7,
          navigation: {
            nextEl: '.swiper-button-recommendations-next',
            prevEl: '.swiper-button-recommendations-prev'
          },
          breakpoints: {
            320: {
              slidesPerView: 2
            },
            480: {
              slidesPerView: 3
            },
            768: {
              slidesPerView: 4
            },
            1024: {
              slidesPerView: 5
            },
            1440: {
              slidesPerView: 6
            }
          }
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        window.onload = () => {
          this.init();
        };
      }

      init() {
        if (this.dataset && this.dataset.url) {
          fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const source = html.querySelector('[data-recommended-products]');
            const target = this.querySelector('[data-recommended-products]');
            
            if (source && source.innerHTML && source.innerHTML.trim().length) {

              // get the limit of recommendations to be displayed and remove whatever is leftover
              const productCount = source.dataset.count;
              source.querySelectorAll('.swiper-slide').forEach((slide,i) => {
                if (i + 1 > productCount) {
                  slide.remove();
                }
              });

              target.innerHTML = source.innerHTML;
            }

            // .update() doesn't work when there are prev/next buttons
            this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

          })
          .catch(e => {
            console.error(e);
          });
        }
      }
    }

    window.ProductRecommendations = ProductRecommendations;

    customElements.define('product-recommendations', ProductRecommendations);

  }

})();